import { lazy } from 'react'

const DashboardAnalytics = lazy(() => import('../../views/dashboard/analytics/index'))

const DashboardRoutes = [
  {
    path: '/dashboard',
    element: <DashboardAnalytics />,
    meta: {
      action: 'read',
      resource: 'Dashboard'
      // restricted: true
    }
  }
]

export default DashboardRoutes
